import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  style: {"font-weight":"bold"},
  class: "col-1 float-start"
}, "開始: ", -1)
const _hoisted_4 = { class: "col-5 float-start" }
const _hoisted_5 = { class: "col-9 float-start" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  style: {"font-weight":"bold"},
  class: "col-1 float-start"
}, "終了: ", -1)
const _hoisted_8 = { class: "col-5 float-start" }
const _hoisted_9 = { class: "col-9 float-start" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = {
  style: {"display":"inline-block","padding":"1%"},
  class: "col-12"
}
const _hoisted_13 = { class: "offset-1 left col-3 input-group-sm float-start" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "left offset-1 col-3 input-group-sm float-start" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "median" }, "中央値", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "avg" }, "平均", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "max" }, "最大", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "min" }, "最小", -1)
const _hoisted_20 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.dateInputChanged && $options.dateInputChanged(...args))),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.startDate) = $event)),
            type: "date",
            id: "start",
            min: "2020-01-01",
            max: "2100-12-31"
          }, null, 544), [
            [_vModelText, $data.startDate]
          ]),
          ($props.useTimeForQueries)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control mt-2",
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.dateInputChanged && $options.dateInputChanged(...args))),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.startTime) = $event)),
                  type: "time",
                  id: "startTime"
                }, null, 544), [
                  [_vModelText, $data.startTime]
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($options.dateInputChanged && $options.dateInputChanged(...args))),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.endDate) = $event)),
            type: "date",
            id: "end",
            min: "2020-01-01",
            max: "2100-12-31"
          }, null, 544), [
            [_vModelText, $data.endDate]
          ]),
          ($props.useTimeForQueries)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control mt-2",
                  onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($options.dateInputChanged && $options.dateInputChanged(...args))),
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.endTime) = $event)),
                  type: "time",
                  id: "endTime"
                }, null, 544), [
                  [_vModelText, $data.endTime]
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_11,
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($data.selectedParticleSize) = $event)),
          class: "form-control",
          style: {"margin":"1%"}
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.times, (t) => {
            return (_openBlock(), _createElementBlock("option", {
              key: t,
              value: t.value
            }, _toDisplayString(t.name), 9, _hoisted_14))
          }), 128))
        ], 512), [
          [_vModelSelect, $data.selectedParticleSize]
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($data.selectedAggregate) = $event)),
          class: "form-control",
          style: {"margin":"1%"}
        }, _hoisted_20, 512), [
          [_vModelSelect, $data.selectedAggregate]
        ])
      ])
    ], 512), [
      [_vShow, $props.showGranularitySelector]
    ])
  ]))
}